import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { store } from './index';

/**
 * Function used to protect any component. It will check that the profile is
 * present and if it is, it will allow the loading of the component. If the
 * profile is not loading, then it will redirect the user to the login page.
 * In order for the context to have a profile loaded, the application needs
 * to go through the login process and load an access token.
 */
export default function withAuth(AuthComponent) {
  return class AuthWrapped extends Component {
    render() {
      if (store.getState().profile.profileId !== undefined) {
        return (<AuthComponent/>);
      } else {
        return (<Redirect to={{
          pathname: '/login',
          state: {
            referrer: window.location.pathname
          }
        }}/>);
      }
    }
  }
}